import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../shared";
import {
  ClientAccountsList,
  ClientAccountSettlement,
  ClientAccountDetailsList,
  ClientAccountStatementDetails,
  CreateOrEditClientAccount,
  ClientAccountTransactionsDetails,
  ClientAccountTransactionsPurchaceDetails,
} from "./containers";
import { OrderDetails } from "../Orders";
import { RefundDetail } from "../Refund";

export const ClientAccountsV2 = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ClientAccountsList />} />
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-modify"]} />}
        >
          <Route path="/edit/:id" element={<CreateOrEditClientAccount />} />
          <Route
            path="/request/:requestId"
            element={<CreateOrEditClientAccount />}
          />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-create"]} />}
        >
          <Route
            path="/details/:id/settlement"
            element={<ClientAccountSettlement />}
          />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-create"]} />}
        >
          <Route path="/create" element={<CreateOrEditClientAccount />} />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-view"]} />}
        >
          <Route path="/details/:id" element={<ClientAccountDetailsList />} />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-modify"]} />}
        >
          <Route
            path="/details/:id/transactions/:t_id"
            element={<ClientAccountTransactionsDetails />}
          />
        </Route>
        <Route
          element={<ProtectedRoute allowedRoute={["client-account-modify"]} />}
        >
          <Route
            path="/details/:clientId/statement/:statementId"
            element={<ClientAccountStatementDetails />}
          />
          {/* On Demand Statement Details */}
          <Route
            path="/details/:clientId/statement"
            element={<ClientAccountStatementDetails />}
          />
          {/* client account purchase details */}
          <Route
            path="/details/:clientId/purchace-details/:id"
            element={<OrderDetails />}
          />
          <Route
            path="/details/:clientId/refund-details/:id"
            element={<RefundDetail />}
          />
        </Route>
      </Routes >
    </>
  );
};
